import { styled } from '@mui/material/styles';
import { GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import { textFieldClasses } from '@mui/material/TextField';
import { inputClasses } from '@mui/material/Input';
import { inputBaseClasses } from '@mui/material/InputBase';
const SovosDataGridToolbarQuickFilter = styled(GridToolbarQuickFilter)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    ["&.".concat(textFieldClasses.root)]: {
      flex: '1 0 auto',
      height: '100%',
      paddingBottom: 0
    },
    ["& .".concat(inputClasses.underline, ":before")]: {
      borderBottom: 'none'
    },
    ["& .".concat(inputBaseClasses.root)]: {
      height: '100%',
      paddingInlineEnd: spacing(),
      paddingInlineStart: spacing(2),
      overflow: 'hidden',
      width: '100%'
    },
    '& svg': {
      fontSize: '22px'
    }
  };
});
export default SovosDataGridToolbarQuickFilter;